import { queryClient } from "@/config/react-query";

/** Shared with useSetupReadiness so the query and its invalidations can't drift. */
export const setupReadinessQueryKeys = {
  all: ["clinicSetupReadiness"] as const,
};

/**
 * Refresh the onboarding checklist.
 *
 * Call this from anything that changes what a readiness row reads: a merchant
 * account, a POS device or terminal order, a phone number, an email domain.
 * The checklist holds its answer for five minutes otherwise, so a clinic that
 * just finished a task sees it still outstanding and does it again.
 *
 * Not a react-query concern that can be automated away — several of these
 * completion actions are plain async calls rather than mutations, so nothing
 * fires for them on their own.
 */
export function invalidateSetupReadiness() {
  return queryClient.invalidateQueries({
    queryKey: setupReadinessQueryKeys.all,
  });
}

/**
 * Drop the cached readiness answer outright, for callers about to navigate.
 *
 * `invalidateSetupReadiness` only resolves once the refetch it triggers has
 * settled, so awaiting it before a navigation puts a network round-trip in
 * front of the click — on a slow connection the control sits there looking
 * broken, which is the complaint it was added to fix. Dropping the entry is
 * synchronous and just as safe: the console layout's redirect bails while
 * readiness is `undefined`, so it can't act on the stale answer either way.
 */
export function resetSetupReadiness() {
  queryClient.removeQueries({ queryKey: setupReadinessQueryKeys.all });
}
